import { ChangeDetectionStrategy, AfterViewInit, Component, ElementRef, inject, OnInit } from '@angular/core';
import { dateFormat, Plan } from '../../core';
import { PrinterService, ProductService, UserService } from '../../services';
import { AnatomicalSideLabelPipe, BaseComponent, BoneTypeLabelPipe, ConvertDatePipe } from '../../shared';
import { ListMaterialTableComponent } from './list-material-table/list-material-table.component';
import { PlatInstrumentConsumTablesComponent } from './plat-instrument-consum-tables/plat-instrument-consum-tables.component';
import { PlatInstrumentDrillTablesComponent } from './plat-instrument-drill-tables/plat-instrument-drill-tables.component';
import { PlatInstrumentGenTableComponent } from './plat-instrument-gen-table/plat-instrument-gen-table.component';
import { PlatInstrumentTrayTablesComponent } from './plat-instrument-tray-tables/plat-instrument-tray-tables.component';


/**
* Main component of BOM PDF print.
*/
@Component({
	selector: 'app-bom-print',
	templateUrl: './prt-bom.component.html',
	imports: [
		ConvertDatePipe,
		BoneTypeLabelPipe,
		AnatomicalSideLabelPipe,
		ListMaterialTableComponent,
		PlatInstrumentGenTableComponent,
		PlatInstrumentTrayTablesComponent,
		PlatInstrumentDrillTablesComponent,
		PlatInstrumentConsumTablesComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PrintBomComponent extends BaseComponent implements OnInit, AfterViewInit {

	private readonly userSrv = inject(UserService);
	private readonly prtSrv = inject(PrinterService);
	private readonly element = inject(ElementRef);
	private readonly prodSrv = inject(ProductService);

	isJPS_Ext = false;
	currentCase?: Plan;
	today = new Date();
	isJPSWarningVisible = false;
	readonly dateFormat = dateFormat();

	private _isDemo = false;

	/**
	 * Watermark Demo.
	 */
	get isDemo(): boolean {
		return this._isDemo;
	}


	ngOnInit(): void {
		this.currentCase = this.canvasSrv.currentCase;
		this.userSrv.isJPSDemoProduct().subscribe(res => this._isDemo = res);
		this.isJPS_Ext = this.prodSrv.jpsExtension;
		this.isJPSWarningVisible = this.prodSrv.isJPSToUpgrade;
	}

	ngAfterViewInit(): void {
		const elem = this.element.nativeElement;
		this.prtSrv.onBomDataReady(elem);
	}

}
